import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { ApiService } from 'src/app/services/api.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ErrorText } from 'src/app/enums/error-text.enum';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ExcludeLeadSourceComponent } from '../exclude-lead-source/exclude-lead-source.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { width } from '@fortawesome/free-brands-svg-icons/faFacebook';

@Component({
  selector: 'fury-third-party-api-list',
  templateUrl: './third-party-api-list.component.html',
  styleUrls: ['./third-party-api-list.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation]
})
export class ThirdPartyApiListComponent implements OnInit, OnDestroy {

  thirdPartyStatus:any = {};
  leadSource = [];
  ngUnsubscribe = new Subject<void>();
  constructor(
    private apiService: ApiService,
    private dialog: MatDialog
  ) {  }

  ngOnInit(): void {
    this.getThirdPartyApiStatus();
    this.getAllLeadSource();
  }
  private _gap = 16;
  gap = `${this._gap}px`;

  getThirdPartyApiStatus(){
   this.apiService.get('admin/settings/third-party-api/get-status').subscribe((res: HttpResponse<any>)=>{
    if(res.body){
      this.thirdPartyStatus = res.body;
    }
   }, err =>{
    if (err){
      this.apiService.alert(ErrorText.SomeThingWentWrong, ErrorType.Error)
    }
   })
  };
  changeStatus(event: MatSlideToggleChange, apiName: string) {
    this.apiService.patch(`admin/settings/third-party-api/change-status/${apiName}`).subscribe((res: any) => {
      if (res.body) {
        this.apiService.alert(res.body.message, ErrorType.Success);
      }
    }, err => {
      if (err) {
        this.apiService.alert(err.errors, ErrorType.Error);
        this.getThirdPartyApiStatus();
      }
    });
  }
  getAllLeadSource(){
    this.apiService.get('admin/settings/third-party-api/get-lead-sources').pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: HttpResponse<any>)=>{
      if(res.body){
        this.leadSource = res.body?.leadSources;
      }
    }, (err: HttpErrorResponse)=>{
      this.apiService.alert(err.message, ErrorType.Error);
    })
  }
  openExcludeLeadSourceModal(thirdPartyApiName:string){
    if (this.leadSource.length) this.dialog.open(ExcludeLeadSourceComponent, 
      {
        width: '400px',
        data: {thirdPartyApiName, leadSource : this.leadSource}
      }
      );
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
